import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";
import PageLines from "../components/PageLines";
import ContactSection from "../components/ContactSection";
import MalaysiaMap from "../components/MalaysiaMap";
import CustomLoader from "../components/CustomLoader";
import { useWOW } from "../hooks/useWOW";

function About() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide loader after 2 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // Initialize WOW.js for scroll animations
  useWOW();

  return (
    <div className="layout">
      {/* Custom Loader */}
      {isLoading && <CustomLoader />}
      {/* Main Header Section */}
      <main
        className="main main-inner bg-about"
        style={{
          backgroundImage: "url('/img/xinchuan/xinchuan_office2.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <header className="main-header">
            <h1>About Us</h1>
          </header>
        </div>
      </main>

      <div className="content">
        {/* About Section */}
        <section id="about" className="about">
          <div className="container">
            <div className="entry">
              <h3 className="entry-title">
                Introduction <span className="text-primary">.</span>
              </h3>
              <p className="entry-text">
                WELCOME TO XIN CHUAN INTERIOR DESIGN & RENOVATION (M) SDN BHD,
                where we believed that every space in your house tells a story.
                Thus, we’re here to help you realize your story to reality.
                <br />
                With half decade of industry experience, we specialize in
                residential and commercial interiors, renovation and offering
                tailored solutions that reflect our client’s personalities and
                business identities. <br />
                Let us transform your space into something truly exceptional.
                Explore our services, view our past projects, and discover how
                our company can bring your story to life
              </p>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section id="services" className="services section">
          <div className="container">
            <header className="section-header">
              <h2 className="section-title">
                <span className="text-primary">Our</span> Services
              </h2>
            </header>
            <div className="section-content">
              <div className="row-services row-base row">
                <div className="col-base col-service col-sm-6 col-md-4 wow fadeInUp">
                  <div className="service-item">
                    <img alt="" src="/img/img-icon/icon-architecture.png" />
                    <h4>Designing</h4>
                    <p>
                      The process of conceptualizing, planning, and detailing
                      interior environments by integrating space planning,
                      material selection, color schemes, lighting design,
                      furniture layout, and decorative elements. It involves
                      understanding client needs, building codes, and aesthetic
                      preferences to create cohesive, functional, and visually
                      appealing interior spaces.
                    </p>
                  </div>
                </div>
                <div
                  className="col-base col-service col-sm-6 col-md-4 wow fadeInUp"
                  data-wow-delay="0.3s"
                >
                  <div className="service-item">
                    <img alt="" src="/img/img-icon/icon-interiors.png" />
                    <h4>Carpentry</h4>
                    <p>
                      The skilled craft of designing, fabricating, and
                      installing custom woodwork and built-in elements—such as
                      cabinetry, furniture, wall paneling, partitions, shelving,
                      and decorative wood details—as part of an interior design
                      project. Carpentry in this context supports both the
                      functional layout and the visual identity of the space,
                      aligning with the overall design concept.
                    </p>
                  </div>
                </div>
                <div
                  className="col-base col-service col-sm-6 col-md-4 wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <div className="service-item">
                    <img alt="" src="/img/img-icon/icon-planing.png" />
                    <h4>Renovation</h4>
                    <p>
                      The process of altering, upgrading, or restoring interior
                      spaces to improve functionality, modernize aesthetics,
                      address wear and tear, or adapt the space to new
                      requirements. Renovation may involve structural
                      modifications, spatial reconfiguration, finishes
                      replacement, fixture upgrades, and integration of new
                      design elements, all in alignment with the client’s vision
                      and the overall design strategy.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Objects Section */}
        {/* Objects/Locations Section */}
        <section id="objects" className="objects section">
          <div className="container">
            <header className="section-header">
              <h2 className="section-title">
                We are <span className="text-primary">all over Malaysia</span>
              </h2>
            </header>

            <div className="section-content">
              <MalaysiaMap />
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <ContactSection />
        <Footer />
        {/* Lines */}
        <PageLines />
      </div>
    </div>
  );
}

export default About;
